import DATATABLE_TRANSLATIONS from "./datatable_translations";

export default class ExamTypesDataTable {
  constructor() {
    $(document).ready(function() {
      showExamTypesTable();
    });

    $(document).on("turbo:render", function() {
      showExamTypesTable();
    });

    function showExamTypesTable() {
      $('#exam-types-datatable').dataTable({
        "order": [],
        "columnDefs": [ {
          "targets"  : 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#exam-types-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          {"data": "name"},
          {"data": "active"},
          {"data": "has_level"},
          {"data": "actions"}
        ]
        // pagingType is optional, if you want full pagination controls.
        // Check dataTables documentation to learn more about
        // available options.
      });
    }
  }
}
